export const GET_USER = "GET_USER"
export const SET_USER = "SET_USER"
export const SET_ROOM_ID = "SET_ROOM_ID"
export const GET_JOINED_ROOMS = "GET_JOINED_ROOMS"
export const SET_JOINED_ROOMS = "SET_JOINED_ROOMS"
export const GET_JOINABLE_ROOMS = "GET_JOINABLE_ROOMS"
export const SET_JOINABLE_ROOMS = "SET_JOINABLE_ROOMS"
export const SIGNED_IN = "SIGNED_IN"
export const SET_MESSAGE = "SET_MESSAGE"
export const GET_MESSAGES = "GET MESSAGES"
export const CLEAR_MESSAGES = "CLEAR MESSAGES"
export const SET_LOADING = "SET_LOADING"
export const GET_LOGS = "GET_LOGS"
export const LOGS_ERROR = "LOGS_ERROR"
